import SimilarProducts from './SimilarProducts';

export default SimilarProducts;
